import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'WB5-U11-P76-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page76/E1/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page76/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page76/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page76/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page76/E1/4.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page76/E1/5.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page76/E1/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page76/E1/7.jpg' },
      ],




    ]
  },
  2: { // Exercise num
    unit: 'Unit 11',
    id: 'WB4-V2-U11-P76-E2',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page76/E2/Key/answerKey.png',
    inputSize: 120,
    // titleImage: "img/FriendsPlus/Page60/E1/1.jpg",
    // titleQuestion: [{ num: '1', title: 'Read the sentences and number the picture.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page76/E2/1.jpg' /> </div>
          <div style=" position: absolute; top: 454px; left: 336px; "><input id='0' /></div>
          <div style=" position: absolute; top: 454px; left: 569px; "><input id='1' /></div>
          <div style=" position: absolute; top: 453px; left: 803px; "><input id='2' /></div>
        </div>
        `,
        answer: [
          "faster",
          "slower",
          "quieter",

        ],
      },
    ],
  },
  3: { // Exercise num
    unit: 'Unit 11',
    id: 'WB5-U11-P76-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page76/E3/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page76/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page76/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page76/E3/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page76/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page76/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page76/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page76/E3/7.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page76/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page76/E3/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page76/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page76/E3/11.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page76/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page76/E3/13.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page76/E3/14.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page76/E3/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page76/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page76/E3/17.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page76/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page76/E3/19.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page76/E3/20.jpg' },
      ],





    ]
  },




}
export default json;